<template>
  <div class="page page-inner">
    <breadcrumb title="Detail Event"></breadcrumb>
    <div class="row">
      <div class="card-fluid col-sm-12 col-md-7 ml-4">
        <div class="card-body ">
          <p class="text-muted ml-3">
            <em class="fa fa-calendar"></em> {{ formatDate(detail.start_date, 4) }} <em class="fa fa-tag"></em> {{detail.category_name}}
          </p>
          <h4 class="font-weight-bold ml-3">{{detail.title}}</h4>
          <div class="row col-md-12">
            <div class="col-md-9 media mb-0">
              <div class="user-avatar user-avatar-lg mt-0">
                <a  class="" data-toggle="tooltip" :title="detail.real_name">
                  <img :src="checkImage(detail.photo, detail.photo_path)" alt="">
                </a>
              </div>
              <div class="media-body">
                <h6 class="font-weight-bold ml-2 mb-0 mt-1">Hosted by</h6>
                <p class="display-5 text-muted ml-2 mb-1"><span class="mr-2">{{detail.organizer}}</span></p>
              </div>
            </div>
            <div class="col-md-3 text-right" >
              <div class="dropdown d-flex mr-md-n3">
                <button type="button" class="btn btn-outline-dark" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><em class="fa fa-share-alt"></em> Share </button>
                <div class="dropdown-menu">
                  <div class="dropdown-arrow ml-3"></div>
                  <a class="dropdown-item" href="javascript:void(0);" @click="Link(detail.id, 'linkedin','' ,'https://linkedin.com/shareArticle')">
                      <em class="fab fa-linkedin"></em> LinkedIn
                  </a>
                  <a class="dropdown-item" href="javascript:void(0);" @click="Link(detail.id, 'twitter', '','https://www.twitter.com/share')">
                    <em class="fab fa-twitter"></em> Twitter
                  </a>
                  <a class="dropdown-item" href="javascript:void(0);" @click="Link(detail.id, 'facebook', '','https://www.facebook.com/sharer/sharer.php')">
                    <em class="fab fa-facebook"></em> Facebook
                  </a>
                  <a class="dropdown-item" href="javascript:void(0);" @click="Link(detail.id, 'whatsapp', detail.title, 'https://api.whatsapp.com/send')">
                    <em class="fab fa-whatsapp"></em> Whatsapp
                  </a>
                </div><!-- /.dropdown-menu -->
              </div>

            </div>
          </div>

          <br/>
          <div class="col-md-12" style="text-align: justify; width:100%">
            <div v-html="detail.content"></div>
          </div>
          <div class="row col-md-12">
            <div class="col-md-9">

            </div>
            <div class="col-md-3 text-right" >
              <button type="button" class="btn btn-outline-dark"><em class="fa fa-bookmark"></em> SAVE EVENT </button>
              <button type="button" class="btn btn-dark ml-1">ATTEND</button>
            </div>
          </div>
        </div>
        <hr/>
        <h5 class="font-weight-bold ml-2">Other Events You May Like</h5>
        <div class="row">
          <div class="col-md-4" v-for="article in articles">
            <div class="media mb-0">
              <div class="mt-0">
                <a @click="toDetailEvent(article.id)" style="color:#121212;text-decoration: none" data-toggle="tooltip"
                   title="">
                  <img class="img-rounded mb-1" :src="article.photo !== null && article.photo !== '' ? urlBackend+'/'+article.path_photo+article.photo : 'assets/images/b432fc7aab82120b441454fe9457a96c.jpg'" width="250px"
                       height="150px" alt="" />
                  <h5 class="font-weight-bold ">{{article.title}}</h5>
                  <p class="text-muted ml-2 mb-1"><em class="fa fa-calendar"></em> {{ formatDate(article.date, 4) }}</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-1"></div>
      <div class="col-sm-12 col-md-3">
        <div class="card card-fluid">
          <div class="card-header nav-scroller">
            <div class="col-md-12 m-2">
                <div class="row col-md-12">
                  <div class="col-md-1">
                    <em class="fa fa-download"></em>
                  </div>
                  <div class="col-md-6">
                    <h6>Downloads</h6>
                  </div>
                </div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-md-12 m-2">
              <div class="row col-md-12" style="cursor:pointer" v-for="item in attachments" @click="downloadFile(item, $event)">
                <span class="col-md-1">
                  <em class="fa fa-file-signature"></em>
                </span>
                <span class="col-md-6">
                  <h6>{{item.name}}</h6>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-fluid">
          <div class="card-header nav-scroller">
            <div class="col-md-12 m-2 dt-bootstrap4">
              <div class="row">
                <div class="col-sm-12 col-md-12">
                  <h6> <em class="fa fa-calendar-times"></em> Event Information</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-md-12 m-2">
              <div class="col-md-12 mb-3">
                <p class="mb-0">Registration</p>
                <h6 class="font-weight-bold">{{formatDate(detail.start_date, 2)}} - {{formatDate(detail.end_date, 2)}}</h6>
              </div>
              <div class="col-md-12 mb-3">
                <p class="mb-0">Preparation</p>
                <h6 class="font-weight-bold"> - </h6>
              </div>
              <div class="col-md-12 mb-3">
                <p class="mb-0">Pre Event</p>
                <h6 class="font-weight-bold"> - </h6>
              </div>
              <div class="col-md-12 mb-3">
                <p class="mb-0">Implementation</p>
                <h6 class="font-weight-bold"> - </h6>
              </div>
              <div class="col-md-12 mb-3">
                <p class="mb-0">Location</p>
                <h6 class="font-weight-bold">{{detail.location}}</h6>
              </div>
              <div class="col-md-12 mb-3">
                <GoogleMapLoader v-if="loaded" class="map"
                    :mapConfig="mapConfig"
                    apiKey="AIzaSyALPWIJHD4R-WCGEAm4agaKSA3QNBTJFVM"
                >
                  <template slot-scope="{ google, map }">
                    <GoogleMapMarker
                        v-for="marker in markers"
                        :key="marker.id"
                        :marker="marker"
                        :google="google"
                        :map="map"
                    />

                  </template>
                </GoogleMapLoader>
              </div>
              <div class="col-md-12 mb-3">
                <p class="mb-0">Sector</p>
                <h6 class="font-weight-bold"> {{detail.place}} </h6>
              </div>
              <div class="col-md-12 mb-3">
                <p class="mb-0">Contact</p>
                <h6 class="font-weight-bold">{{detail.contact_email}}</h6>
              </div>
              <div class="col-md-12 mt-3">
                <button type="button" class="btn btn-outline-dark" ><em class="fa fa-calendar font-weight-light"></em> Add To Calendar  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-1"></div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import FormatDate from "../../../../libs/FormatDate";
import GoogleMapLoader from "../../GoogleMap/GoogleMapLoader";
import GoogleMapMarker from "../../GoogleMap/GoogleMapMarker";
import {mapSettings} from "../../constant/mapSettings";
export default {
name: "DetailEvent",
  data(){
    return {
      loaded:false,
      id:"",
      markers:[
        {
          id: "a",
          position: { lat: -7.792875, lng: 110.369351}
        }
      ],
      detail :{
        title:"",
        category_name:"",
        date:"",
        emp_name:"",
        department:"",
        photo_path:""
      },
      articles:[],
      attachments:[],
      urlBackend:process.env.VUE_APP_URL_BACKEND,
      urlFrontend:location.host
    }
  },
  components:{
    Breadcrumb,
    GoogleMapLoader,
    GoogleMapMarker
  },
  computed: {
    mapConfig() {
      return {
        ...mapSettings,
        center: { lat: -7.792875, lng: 110.369351 }
      }
    },
  },
  methods:{
    toDetailEvent(id){
      // this.$router.push({name:"DetailEvent", query:{id:""}})
      this.id = id
      this.getDetailEvent()
    },
    getDetailEvent(){
      let userProfile = this.$store.getters.userProfile
      let payload = {
        id: (this.id),
        lang:"en",
        company_id:userProfile.data.attributes.company_id
      }
      AxiosCall.Get(payload, urlApi.events.detail).then(res=>{
        if (res.success){
          this.detail = res.atributes
          this.markers = []
          this.markers.push({id:this.detail.title, position: {lat:parseFloat(this.detail.latitude), lng:parseFloat(this.detail.longitude)}})
          this.mapConfig.center = {lat:parseFloat(this.detail.latitude), lng:parseFloat(this.detail.longitude)}
          this.loaded = true
          this.getRelatedArticles()
          this.getAttachmentFile()
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        console.log(e)
      })
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    formatDate(val, format){
      return val !== undefined ?  FormatDate(val, format) : ""
    },
    checkImage(val, path){
      return (val === null || val === "") ? "assets/images/user-photo.png" : this.urlBackend+path+val
    },
    getRelatedArticles(){
      let payload = {
        id:this.detail.id
      }
      AxiosCall.Get(payload, urlApi.events.related_articles).then(res=>{
        if(res.success){
          this.articles = res.atributes
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    Link(id, app, title, host) {
      let url = this.urlFrontend+'/detail-event?id='+btoa(id)
      switch (app) {
        case "whatsapp":
          window.open(
              'https://api.whatsapp.com/send' +
              this.objectToGetParams({
                text: title ? title + " " + url : url
              }),
              '__blank'
          );
          break;
        case "facebook":
            window.open(
                `https://www.facebook.com/sharer/sharer.php` +
                this.objectToGetParams({
                  u: url
                }),
                '__blank'
            );
            break
        default:
          window.open(
              host +
              this.objectToGetParams({
                mini: true,
                url: url
              }),
              '__blank'
          );
          break
      }
    },
    objectToGetParams(object) {
      return (
          '?' +
          Object.keys(object)
              .filter(key => !!object[key])
              .map(key => `${key}=${encodeURIComponent(object[key])}`)
              .join('&')
      );
    },
    getAttachmentFile(){
      let payload = {
        id:this.detail.id
      }
      AxiosCall.Get(payload, urlApi.events.list_attachment).then(res=>{
        if(res.success){
          this.attachments = res.atributes
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    downloadFile(item, evt){
      evt.preventDefault()
      window.open(this.urlBackend+item.file_path+item.file_name, '_blank');
    }
  },
  created() {
  this.id = atob(this.$route.query.id)
    this.getDetailEvent()
  },
}
</script>

<style scoped>
.img-rounded{
  border-radius: 1rem;
}
.text-right {
  text-align: right;
}
.map{
  height:400px;
}
</style>